const TWILIO_DEV_BASE_URL = 'http://localhost:8887'

const getBaseUrl = (path: string): string => {
  if (process.env.NODE_ENV === 'development' && path.startsWith('/twilios/')) {
    return TWILIO_DEV_BASE_URL
  }

  return process.env.API_URL || ''
}

export default getBaseUrl
